import { Routes } from '@angular/router';
import { LoginComponent } from './modules/auth/login/login.component';
import { authGuard } from './core/guards/auth.guard';
import { AlreadyAuthenticatedGuard } from './core/guards/alreadyAuthenticatedGuard.guard';
import { ViewScanRetailQrResultComponent } from './core/pages/view-scan-retail-qr-result/view-scan-retail-qr-result.component';

export const routes: Routes = [
  {
    path: "login",
    component: LoginComponent,
    canActivate: [AlreadyAuthenticatedGuard],

  },
  {
    path: "scan-result/:retailQrId/:customerId",
    component: ViewScanRetailQrResultComponent,
  },
  {
    path: '',
    loadChildren: () => import('./modules/main-layout/main-layout-routing.module').then(m => m.mainLayoutRoutes),
    canActivate: [authGuard],
  }
];
